const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	PanelBody,
	SelectControl,
	Disabled,
	ToggleControl
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/multimedia", {
	title: __("Multimédia et documents", "wp-apidae"), // Block title.
	description: __("Affiche les éléments multimédias ainsi que les documents à télécharger.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.multimedia
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		plan: {
			type: "boolean",
			default: true,
		},
		document: {
			type: "boolean",
			default: true,
		},
		video: {
			type: "boolean",
			default: true,
		},
		logo: {
			type: "boolean",
			default: false,
		},
		webcam: {
			type: "boolean",
			default: false,
		},
		webcam_360: {
			type: "boolean",
			default: false,
		},
		visite_virtuelle: {
			type: "boolean",
			default: false,
		},
		brochure_virtuelle: {
			type: "boolean",
			default: false,
		},
		bon_plan: {
			type: "boolean",
			default: false,
		},
		application_iphone: {
			type: "boolean",
			default: false,
		},
		application_ipad: {
			type: "boolean",
			default: false,
		},
		application_android: {
			type: "boolean",
			default: false,
		},
		application_android_tablette: {
			type: "boolean",
			default: false,
		},
		show_title: {
			type: "boolean",
			default: true,
		},
		field_tag: {
			type: 'string',
			default: 'h2',
		},
		ss_field_tag: {
			type: 'string',
			default: 'h3',
		},
		open_links: {
			type: 'string',
			default: '_blank',
		},
		align: {
			type: 'string',
			default: '',
		},
	},

	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;
			const fieldsTags          = window.WpApidaeTemplateData.fieldsTags;

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("Affichage")}>
							<ToggleControl
								label={ __( 'Plans' ) }
								checked={ attributes.plan }
								onChange={ () => {
									props.setAttributes({ plan: ! attributes.plan });
								} }
							/>
							<ToggleControl
								label={ __( 'Documents' ) }
								checked={ attributes.document }
								onChange={ () => {
									props.setAttributes({ document: ! attributes.document });
								} }
							/>
							<ToggleControl
								label={ __( 'Videos' ) }
								checked={ attributes.video }
								onChange={ () => {
									props.setAttributes({ video: ! attributes.video });
								} }
							/>
							<ToggleControl
								label={ __( 'Logos' ) }
								checked={ attributes.logo }
								onChange={ () => {
									props.setAttributes({ logo: ! attributes.logo });
								} }
							/>
							<ToggleControl
								label={ __( 'Webcams' ) }
								checked={ attributes.webcam }
								onChange={ () => {
									props.setAttributes({ webcam: ! attributes.webcam });
								} }
							/>
							<ToggleControl
								label={ __( 'Webcams 360' ) }
								checked={ attributes.webcam_360 }
								onChange={ () => {
									props.setAttributes({ webcam_360: ! attributes.webcam_360 });
								} }
							/>
							<ToggleControl
								label={ __( 'Visites virtuelles' ) }
								checked={ attributes.visite_virtuelle }
								onChange={ () => {
									props.setAttributes({ visite_virtuelle: ! attributes.visite_virtuelle });
								} }
							/>
							<ToggleControl
								label={ __( 'Brochures virtuelles' ) }
								checked={ attributes.brochure_virtuelle }
								onChange={ () => {
									props.setAttributes({ brochure_virtuelle: ! attributes.brochure_virtuelle });
								} }
							/>
							<ToggleControl
								label={ __( 'Bons plans' ) }
								checked={ attributes.bon_plan }
								onChange={ () => {
									props.setAttributes({ bon_plan: ! attributes.bon_plan });
								} }
							/>
							<ToggleControl
								label={ __( 'Application Iphone' ) }
								checked={ attributes.application_iphone }
								onChange={ () => {
									props.setAttributes({ application_iphone: ! attributes.application_iphone });
								} }
							/>
							<ToggleControl
								label={ __( 'Application Ipad' ) }
								checked={ attributes.application_ipad }
								onChange={ () => {
									props.setAttributes({ application_ipad: ! attributes.application_ipad });
								} }
							/>
							<ToggleControl
								label={ __( 'Application Android' ) }
								checked={ attributes.application_android }
								onChange={ () => {
									props.setAttributes({ application_android: ! attributes.application_android });
								} }
							/>
							<ToggleControl
								label={ __( 'Application Android tablette' ) }
								checked={ attributes.application_android_tablette }
								onChange={ () => {
									props.setAttributes({ application_android_tablette: ! attributes.application_android_tablette });
								} }
							/>
						</PanelBody>
						<PanelBody title={__("Options")}>
						<ToggleControl
								label={ __( 'Afficher un titre de section' ) }
								checked={ attributes.show_title }
								onChange={ () => {
									props.setAttributes({ show_title: ! attributes.show_title });
								} }
							/>
							{ true === attributes.show_title &&
							<SelectControl
							label={ __( 'Balise à utiliser' ) }
							value={ attributes.field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									field_tag: newValue,
								});
							}}
						/>}
						<SelectControl
							label={ __( 'Balise des sous titres' ) }
							value={ attributes.ss_field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									ss_field_tag: newValue,
								});
							}}
						/>
						<SelectControl
							label={ __( 'Ouverture des liens' ) }
							value={ attributes.open_links }
							options={[{label: 'Nouvelle fenêtre', value: '_blank'},{label: 'Fenêtre courante', value: '_self'}]}
							onChange={ newValue => {
								props.setAttributes({
									open_links: newValue,
								});
							}}
						/>
						</PanelBody>
					</InspectorControls>,
						<Disabled>
						<ServerSideRender
							block="wp-apidae/multimedia"
							attributes={attributes}
							urlQueryArgs={{
							settings:template
						}}/>
					</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
